module.exports = __webpack_public_path__ + "img/face_shape_female_extra_rect.7fd5978d.png";